export function slottingScanCursor(value:unknown){
 if(value==='')return null;
 if(typeof value!=='string'||!/^(0|[1-9]\d*):(0|[1-9]\d*):[1-9]\d*$/.test(value))throw new Error('Choose a valid suggestion scan page.');
 const [score,units,id]=value.split(':').map(Number);
 if(![score,units,id].every(Number.isSafeInteger))throw new Error('Choose a valid suggestion scan page.');
 return {score,units,id};
}
export function nextSlottingScanPage(next:unknown,previous:string){
 try{const n=slottingScanCursor(next),p=slottingScanCursor(previous);return !!n&&(!p||n.score<p.score||n.score===p.score&&(n.units<p.units||n.units===p.units&&n.id>p.id));}catch{return false;}
}
